// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2oIIm","error":"Textarea_error__3uuMc","readonly":"Textarea_readonly__cm8Rw","disabled":"Textarea_disabled__2cZvn"};